import { render, staticRenderFns } from "./VideoJsPlayer.vue?vue&type=template&id=9f6c5738&"
import script from "./VideoJsPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoJsPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports